import {BaseModel} from './base.model';
import {UserModel} from './user.model';

export class EmailModel extends BaseModel {

    address: string;
    user_id: number;

    //associations
    user: UserModel

    static validate(email: EmailModel): boolean {
        return !!(email.address);
    }

    constructor(email?: EmailModel) {
        super();
        this.address = email ? email.address || null : null;
        this.user_id = email ? email.user_id || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/email.model.ts